import { CATEGORIES, STATUSES } from './feedbackMeta';

const fmt = (n) => (typeof n === 'number' ? n.toLocaleString('en-US') : '…');

/**
 * All · status tabs · category tabs; one selected at a time. Counts come from the API and
 * ignore the selected tab, so they stay stable while switching.
 */
export default function FeedbackTabs({ status, category, counts, onSelect }) {
  const tabs = [
    { id: 'all', label: 'All', count: counts?.all, selected: status === 'all' && category === 'all', changes: { status: 'all', category: 'all' } },
    ...STATUSES.map((s) => ({
      id: `status-${s.key}`,
      label: s.label,
      dot: s.dot,
      count: counts ? counts.byStatus[s.key] ?? 0 : undefined,
      selected: category === 'all' && status === s.key,
      changes: { status: s.key, category: 'all' },
    })),
    ...CATEGORIES.map((c) => ({
      id: `category-${c.key}`,
      label: c.chip,
      count: counts ? counts.byCategory[c.key] ?? 0 : undefined,
      selected: category === c.key,
      changes: { status: 'all', category: c.key },
    })),
  ];

  return (
    <div role="radiogroup" aria-label="Filter feedback" className="flex gap-2 overflow-x-auto pb-1 -mb-1 [scrollbar-width:thin]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="radio"
          aria-checked={tab.selected}
          onClick={() => !tab.selected && onSelect(tab.changes)}
          className={`shrink-0 h-9 px-3.5 rounded-lg text-[13px] font-semibold inline-flex items-center gap-2 whitespace-nowrap transition-colors outline-none focus-visible:ring-2 focus-visible:ring-status-ok-dot focus-visible:ring-offset-1 ${
            tab.selected
              ? 'bg-primary text-on-primary shadow-xs'
              : 'bg-surface-container-lowest text-on-surface-variant border border-outline-variant/30 hover:bg-surface-container-low hover:text-on-surface'
          }`}
        >
          {tab.dot && <span className={`w-2 h-2 rounded-full ${tab.dot}`} aria-hidden="true" />}
          {tab.label}{' '}
          <span className={`font-data-mono text-xs ${tab.selected ? 'text-on-primary-container' : ''}`}>{fmt(tab.count)}</span>
        </button>
      ))}
    </div>
  );
}
